import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LocationRadiusModalModule } from '../keepalive/components/location-radius-modal/location-radius-modal.module';
import { CDRRoutingModule } from './cdr-routing.module';
import { DataModule } from '../keepalive/components/data/data.module';
import { ToolsModule } from '../tools/tools.module';
import { CdrDevicesComponent } from './pages/cdr-devices/cdr-devices.component';
import { FiltersModule } from '../tools/filters/filters.module';
import { CdrDashboardPageComponent } from './pages/cdr-dashboard/cdr-dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { MatRowComponent } from '../tools/mat-row/mat-row.component';
import { MatColComponent } from '../tools/mat-col/mat-col.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { TimeAgoExtendsPipe } from '../tools/pipes/time-ago.pipe';
import { CdrMapComponent } from './pages/map/cdr-map.component';
import { CurrentSimLocationsComponent } from '@huge-monorepo/shared/pages';
import { Endpoints, GenericService } from '@huge-monorepo/hip/services';

@NgModule({
  declarations: [CdrDevicesComponent, CdrDashboardPageComponent, CdrMapComponent],
  imports: [CommonModule, LocationRadiusModalModule, CDRRoutingModule, ToolsModule, FiltersModule, DataModule, ToastrModule, MatRowComponent, MatColComponent, MaterialModule, CurrentSimLocationsComponent],
  providers: [TimeAgoExtendsPipe, DatePipe, Endpoints, GenericService],
})
export class CdrModule {}
